import {mergeGraph, registerGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('fuelUsageGraph', fuelUsageGraph);

/* @ngInject */
function fuelUsageGraph(GraphService, locale, defaultGraph) {
    const GraphColors = GraphService.colors;
    return mergeGraph(defaultGraph(), {
        options: {
            colors: [GraphColors.blue],
        },
        xAxis: {
            labels: {
                formatter: function () {
                    if (this.value == 0) return '0 ' + locale.getString('graph.load');
                    if (this.value == 0.25) return '1/4 ' + locale.getString('graph.load');
                    if (this.value == 0.50) return '1/2 ' + locale.getString('graph.load');
                    if (this.value == 0.75) return '3/4 ' + locale.getString('graph.load');
                    if (this.isLast) return locale.getString('graph.full_load');
                    return '';
                }
            },
            tickInterval: 0.25,
            minorGridLineWidth: 0
        },
        yAxis: [
            {
                title: {
                    text: locale.getString('graph.Lhr'),
                    align: 'high',
                    y: -20,
                    rotation: 0,
                    offset: 5
                },
                gridLineWidth: 0,
            }
        ],
        series: [
            {
                name: locale.getString('graph.fuel_usage'),
                color: GraphColors.blue,
                index: 0,
                visible: false,
                data: []
            },
        ]
    });
}
